import editrecord from '../../assets/editrecord.png';
import document from '../../assets/document.png';
import { useEffect, useRef, useState } from 'react';
import UploadFileModal from './uploadfilemodal';
import { useNavigate } from 'react-router-dom';
import { Backdrop, CircularProgress, Tooltip } from '@mui/material';
import api from 'api/api';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import ToastMessage from 'utils/muialerts/righttoptoast';
import ViewCarouselIcon from '@mui/icons-material/ViewCarousel';
import ShowPdf from './showpdf';
import arrowleft from '../../assets/arrowleft.png';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
import { FaCheckCircle } from 'react-icons/fa';
import gridicon from '../../assets/gridicon.png'
import list from '../../assets/list.png'
import MenuIcon from '@mui/icons-material/Menu';
import GridViewIcon from '@mui/icons-material/GridView';
import uploadicon from '../../assets/uploadicon.png'
import DocView from './docview';
import useModalStore from 'zustand/zustandstore';
import BasicDocView from './basicdocView';
import Corousel from './corousel/corousel';
import FlickingCor from './corousel/flickingcor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PromptActionsModal from './promptactions';
import SideBarWrapper from 'version2/sidebarwrap';
import V2header from 'version2/v2header';
import addwhite from '../../assets/addwhite.png'
import backarraow from '../../assets/backarraow.png'
import coroselv2 from '../../assets/coroselv2.png'
import gridv2 from '../../assets/gridv2.png'
import listv2 from '../../assets/listv2.png'
import deletered from '../../assets/delete.png'
import updatev2 from '../../assets/updatev2.png'
import viewvv2 from '../../assets/viewv2.png'
import intructionsv2 from '../../assets/intructionsv2.png'
import defaultv2 from '../../assets/defaultv2.png'
import SectionUpdate from './modals/sectionupdate';
import TemplateUpdate from 'version2/modals/templateupdate';
const ManageTemplate = () => {
  // Array of cards with template names
  const [isuploadmodal,setIsuploadmodal]=useState(false)
  const [ispdfshow,setIspdfShow]=useState(false)
  const mydata=useModalStore()
  const[file,setFile]=useState('')
  const[selectedTemplate,setSelectedTemlate]=useState('')
  const [defTemplatePrompt,setDefTemplatePrompts]=useState([])
  const [deftemplates,setDeftemplates]=useState([])
  const [pdffile,setPdffile]=useState()
  const [loading,setLoading]=useState(false)
  const [alertmessage, setAlertMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [default_template,setDefaulttemplate]=useState('')
  const [severity, setSeverity] = useState('success');
  const[extractionResponse,setExtractionResponse]=useState('')
  const [pId,setPId]=useState('')
    const [isPromptactions,setIspromptActions]=useState(false)
  const[dId,SetDId]=useState('')
  const [isListView,setListView]=useState('corousel')
  const [isupdatemodal,setIsupdatemodal]=useState(false)
  const navigate=useNavigate()
  const[cards,setCards]=useState([])
  const [sortedCards, setSortedCards] = useState([]);
  const[user,setuser]=useState()
  const scrollRef = useRef(null);
  useEffect(() => {
    
      const sorted = [...cards].sort((a, b) => {
      const keyA = Object.keys(a)[0];
      const keyB = Object.keys(b)[0];
      return keyA === default_template ? -1 : keyB === default_template ? 1 : 0;
    });

    setSortedCards(sorted);

  }, [cards,default_template]);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

const fetchBasicData=async()=>{
  try {
  setLoading(true)
    const response=await api.get('/v1/user_templates/default_populated_templates')
    
    if(response.status==200){
      
      setCards(response.file_names)
              }else{
               
                setCards([])
              }
  } catch (error) {
    console.log(error)
  }finally{
setLoading(false)

  }
}
function mergeTemplates(collectedTemplates, userTemplates) {
  const templateMap = new Map();
  console.log(collectedTemplates,'collectedTemplates')

  const collected = Array.isArray(collectedTemplates) ? collectedTemplates : [];
  const user = Array.isArray(userTemplates) ? userTemplates : [];

  // Helper to get the first key of a template object
  const getFirstKey = (template) => {
    if (template && typeof template === 'object' && !Array.isArray(template)) {
      const keys = Object.keys(template);
      return keys.length > 0 ? keys[0] : null;
    }
    return null;
  };

  // Collected templates take priority
  for (const template of collected) {
    const key = getFirstKey(template);
    if (key) {
      templateMap.set(key, template);
    }
  }

  // Add user templates only if the first key is not already in the map
  for (const template of user) {
    const key = getFirstKey(template);
    if (key && !templateMap.has(key)) {
      templateMap.set(key, template);
    }
  }

  return Array.from(templateMap.values());
}



  const fetchdata=async()=>{
    try {
      setLoading(true)
      const response = await api.get('/auth/me')
      setuser(response)
      if (response && response.templates && response.templates.default_template) {
                  setDefaulttemplate(response.templates.default_template);
                  setSelectedTemlate(response.templates.default_template)
      }
      if (response && response.config) {
        const practiceIdString = String(response.config.practiceid); 
        const departmentIdString = String(response.config.departmentid);
      setPId(practiceIdString)
      SetDId(departmentIdString)
    
        const basictemp=await api.get('/v1/user_templates/default_populated_templates')
           const dataRes = await api.get("/v1/user_templates/get_populated_templates");
              let basic=[]
        
         if(basictemp.status==200){
      basic=basictemp.file_names
      setCards(basic)
     setDeftemplates(basic||[])
        }
        
        if (response.templates && Array.isArray(response.templates.templates)) {
          setDefTemplatePrompts(response.templates.templates)
          const transformedTemplates = response.templates.templates
          .filter(obj => obj.template ) // Ensure required keys exist
          .map(obj => ({
              [obj.template]: { prompt: obj.prompt,instructions:obj?.instructions, },
              populatedtemp: dataRes?.file_names?.find(item => {
                const firstKey = Object.keys(item)[0];
                return firstKey === obj.template;
              })?.[obj.template]
             
          }));
       

             setCards(mergeTemplates([...basic],[...transformedTemplates]))

      
      }

    

          
        
     
      }
      
    } catch (error) {
      console.log(error)

    }finally{
      setLoading(false)
    }

  }
useEffect(()=>{
  if(mydata.usertype === 'BASIC'){
fetchBasicData()
  }else if(mydata.usertype === 'PLUS'||mydata.usertype=='PRO'){
    fetchdata()
  }
},[])

const handleUploadSavedTemplate=async()=>{
  setLoading(true)
  try {
    const  savetemplate=await api.post('/v1/user_templates/save_template',{
      "practiceid": pId,
      "departmentid":dId,
      "filename": file.name,
      "note_json": extractionResponse
    
    })
if(savetemplate.status===200){
  setAlertMessage('Successfully saved the template') 
  setOpen(true)
  setFile('')
}else{
  setAlertMessage('Something Went Wrong, Try Again') 
  setOpen(true)
}
  } catch (error) {
    setAlertMessage('Something Went Wrong, Try Again') 
  setOpen(true)
    console.log(error)
  }finally{
setLoading(false)
fetchdata()
  }
}


const markasdefault= async(prop)=>{

  try {
    let response= await api.put('/v1/users/update-templates',{
"default_template":prop
    })
   
    if(response.status===200){
   
      setAlertMessage(response.message) 
      setOpen(true)
      fetchdata()
      if (scrollRef.current) {
        scrollRef.current.scrollTop = 0;
      }
    }else{
      setAlertMessage(response.message) 
      setOpen(true)
    }
  } catch (error) {
    console.log(error)
  }


}
const handleSelfEdit = () => {
  navigate(`/edit-temp/${file.name}/self`, { state: { extractionresponse:extractionResponse } });
};

const handleShowpdf = async (filename) => {
  try {
    setLoading(true);

    // Append a timestamp to avoid caching
    const timestamp = new Date().getTime();
    let response;
    let templateKeys = [];
    templateKeys = deftemplates.flatMap(obj => 
      obj && typeof obj === 'object' ? Object.keys(obj) : []
    );
if(mydata.usertype==='BASIC'|| (filename && templateKeys.includes(filename))){
response = await api.get(
      `/v1/user_templates/default_templates_docs/PDF/${filename}?timestamp=${timestamp}`,
      {
        responseType: "blob",
      }  
    )

}else{
 response = await api.post(
      `/v1/user_templates/sample_note/PDF?timestamp=${timestamp}`, // Add timestamp here
      {
        departmentid: dId,
        practiceid: pId,
        filename: filename,
      },
      {
        responseType: "blob",
      }
    );

}
   

    const pdfBlob = new Blob([response], { type: "application/pdf" });

    setPdffile(pdfBlob);
    setIspdfShow(true);
  } catch (error) {
    console.log(error);
  } finally {
    setLoading(false);
  }
};

 const handleDel=async()=>{
    try {
   
        setLoading(true)
        const response=await api.delete('/v1/user_templates/remove',{
            data:{
                "filename":selectedTemplate
            }
          
        })
        if(response.status==200){
          setSeverity('success')
        setAlertMessage('File Sucessfully Deleted');
        setOpen(true)
       
  
        }else if(response.status==201){
          setSeverity('error')
          setAlertMessage(response.message);
          setOpen(true)
        }
        else{
          setSeverity('error')
            setAlertMessage('something went wrong');
            setOpen(true)
        }
    } catch (error) {
        
    }finally{
setLoading(false)
fetchBasicData()
window.location.reload();
    }

  }
  return (
    <>
 <div className='w-full min-h-screen pb-4 sm:pb-0'>
      <V2header/>
        <div onClick={()=>navigate(-1)} className='flex cursor-pointer relative w-full gap-8  items-start p-4'>

<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <g clip-path="url(#clip0_7403_35126)">
    <path d="M22 11.6875H2.68555L11.1396 20.1416L10.1729 21.1084L0.0644531 11L10.1729 0.891602L11.1396 1.8584L2.68555 10.3125H22V11.6875Z" fill="black"/>
  </g>
  <defs>
    <clipPath id="clip0_7403_35126">
      <rect width="22" height="22" fill="white"/>
    </clipPath>
  </defs>
</svg>
    
 

  </div>
        
     <div className="flex items-center justify-center w-full h-auto ">
      <div className=" relative w-[95%] sm:w-[90%] min-h-[50px] h-auto md:mt-10  bg-white rounded-[20px] shadow-[0px_2px_13px_#00000040] pb-8 mb-10">     
      <div className='w-full p-8 flex flex-wrap gap-2 sm:gap-0 justify-center sm:justify-between items-center border-b pb-4 border-gray-300'>
    <div className="text-xl font-medium [font-family:'Poppins-Medium',Helvetica] text-black tracking-[0] leading-[normal] whitespace-nowrap">
    Manage Templates
  </div> 
   <div className='flex gap-4 items-center mt-4 sm:mt-0'>
  <div className='flex  items-center rounded-lg border border-[#E5E7EB] bg-[#F8FAFC] px-1'>
  <div className={`p-1 w-8 ${isListView === 'menu' ? 'bg-white rounded shadow-sm' : ''}`}>
    <img
      onClick={() => setListView('menu')}
      src={listv2}
      alt="list"
      className={`w-4 h-4 cursor-pointer ${isListView === 'menu' ? 'bg-white rounded shadow-sm' : ''}`}
    />
  </div>
  <div className={`p-1 w-8 ${isListView === 'grid' ? 'bg-white rounded shadow-sm' : ''}`}>
    <img
      onClick={() => setListView('grid')}
      src={gridv2}
      alt="grid"
      className={`w-4 h-4 cursor-pointer ${isListView === 'grid' ? 'bg-white rounded shadow-sm' : ''}`}
    />
  </div>
  <div className={`p-1 w-8 ${isListView === 'corousel' ? 'bg-white rounded shadow-sm' : ''}`}>
    <img
      onClick={() => setListView('corousel')}
      src={coroselv2}
      alt="corosel"
      className={`w-6 h-6 cursor-pointer ${isListView === 'corousel' ? 'bg-white rounded shadow-sm' : ''}`}
    />
  </div>
</div>
{mydata.usertype==='PLUS'||mydata.usertype=='PRO'?<button
    onClick={() => setIsuploadmodal(true)}
    className="bg-[#2563EB] flex items-center justify-center gap-2 px-4 py-2 rounded-md text-white font-[Tahoma] text-sm">
      <img src={addwhite} alt="Add" className="w-4 h-4" />
      New
    </button>:<></>}
    </div>
      
      </div>
 
      <div className='w-full px-8'>

{((selectedTemplate)&&(mydata.usertype==='PLUS'||mydata.usertype=='PRO'))?
<div className="rounded-lg border  border-[#E5E7EB] bg-white shadow-md p-4 mt-4">
<p className="text-[#334155] text-md font-medium text-start mb-2">Actions</p>
<div className="w-full flex flex-row flex-wrap gap-4">
  {mydata.usertype === 'PLUS' && (
    <button
      onClick={() => handleDel()}
      disabled={cards.length === 1 || selectedTemplate === 'HnP' || selectedTemplate === 'soap_note'}
      className={`rounded-md border font-medium flex-1 flex items-center gap-2 border-[#E4E4E7] px-4 py-2 text-[#EF4343] bg-white ${
        cards.length === 1 || selectedTemplate === 'HnP' || selectedTemplate === 'soap_note'
          ? 'cursor-not-allowed'
          : 'hover:bg-red-600 hover:text-white'
      }`}
    >
      <img src={deletered} alt="" className="w-4 h-4" />
      Delete Template
    </button>
  )}

  {/* <button
    onClick={() => setPuroseModal(true)}
    className={`rounded-md border flex-1  font-medium flex items-center gap-2 border-[#E4E4E7] px-4 py-2 ${
      selectedTemplate ? 'text-black bg-white' : 'cursor-not-allowed'
    }`}
  >
    <img src={updatev2} alt="" className="w-4 h-4" />
    Update
  </button> */}
      {selectedTemplate && ![].includes(selectedTemplate) ? (
  <button
    onClick={() => 
      // navigate(`/edit-temp/${selectedTemplate}/ind`)
      setIsupdatemodal(true)
    }
    disabled={!selectedTemplate}
    className={`rounded-md border flex-1 font-medium flex items-center gap-2 border-[#E4E4E7] px-4 py-2 ${
      selectedTemplate ? 'text-black bg-white' : 'cursor-not-allowed'
    }`}
  >
    <EditIcon sx={{color:"blue"}}/>
    Edit Template
  </button>
) : null}
  {/* <button
    onClick={(e)=>
      {
        e.stopPropagation()
      setIspromptActions(true)
      }    
      } 
    className={`rounded-md border flex-1 font-medium flex items-center gap-2 border-[#E4E4E7] px-4 py-2 ${
      selectedTemplate ? 'text-black bg-white' : 'cursor-not-allowed'
    }`}
  >
    <img src={intructionsv2} alt="" className="w-4 h-4" />
    Instructions
  </button> */}
  <button
   onClick={(e)=>
    {
      e.stopPropagation()
      handleShowpdf(selectedTemplate)}} 
    className={`rounded-md border flex-1 font-medium flex items-center gap-2 border-[#E4E4E7] px-4 py-2 ${
      selectedTemplate ? 'text-black bg-white' : 'cursor-not-allowed'
    }`}
  >
    <img src={viewvv2} alt="" className="w-4 h-4" />
    View Template
  </button>


    {(selectedTemplate!==default_template)?<button
    onClick={()=>markasdefault(selectedTemplate)}
    className={`rounded-md border flex-1 font-medium flex items-center gap-2 border-[#E4E4E7] px-4 py-2 ${
      selectedTemplate ? 'text-black bg-white' : 'cursor-not-allowed'
    }`}
  >
    <img src={defaultv2} alt="" className="w-4 h-4" />
    Default Template
  </button>:<></>}
</div>
</div>

:<></>
}
</div>


       


{selectedTemplate && mydata.usertype === 'BASIC' && (
  <div className='w-full px-4'>
      <div className="rounded-lg border  border-[#E5E7EB] bg-white shadow-md p-4  mt-4">
<p className="text-[#334155] text-md font-medium text-start mb-2">Actions</p>
<div className="w-full flex justify-center gap-4">
<button
   onClick={(e)=>
    {
      e.stopPropagation()
      handleShowpdf(selectedTemplate)}} 
    className={` rounded-md border font-medium flex items-center gap-2 border-[#E4E4E7] px-4 py-2 ${
      selectedTemplate ? 'text-black bg-white' : 'cursor-not-allowed'
    }`}
  >
    <img src={viewvv2} alt="" className="w-4 h-4" />
    View Template
  </button>
 
  </div>
  </div>
    </div>

)}



        {isListView=='menu'?
        <div ref={scrollRef} className="mt-4 px-8 h-[45vh] overflow-y-auto custom-scrollbar">
        {(sortedCards.length)?sortedCards.map((file, index) => {
  // Extract the key of the template, which is "1st_template" in your case
  const templateName = Object.keys(file)[0];
   return (<div className='flex items-center justify-center'>
    <div className='w-full flex items-center gap-4 '>
      {/* <div className='h-[60px] py-2 mb-4 flex items-center'>
       <div
  className="w-4 h-4 border-2 border-[#2563EB] rounded-full  flex items-center justify-center"
  
>
  {templateName===default_template?<div className="w-2 h-2 bg-[#2563EB] rounded-full" />:<></>}
</div>   
      </div> */}
 

 <div
  key={index}
  className={`w-full min-h-[60px] cursor-pointer mx-auto border border-l-[8px] border-l-[#A2C6FD] ${
    templateName === selectedTemplate 
      ? 'border-[#A2C6FD] border-[3px] ' 
      : 'border-[#D1D1D1]'
  } rounded-md px-4 py-2 mb-4 flex items-center justify-between`}
  // onClick={() => handleShowpdf(templateName)}
  onClick={(e) => {
    e.stopPropagation();
    setSelectedTemlate(templateName);
    // markasdefault(templateName)
  }}
>
      <div className="flex items-center gap-4">
        {/* <img src={document} 
        onClick={()=>handleShowpdf(templateName)}
        className="w-6 h-6 cursor-pointer" alt="document" /> */}
      <div className="[font-family:'Poppins-Regular',Helvetica] font-semibold text-start text-[#262629] text-[13px] tracking-[0] leading-[normal]">
        {templateName === 'HnP' 
    ? 'History & Physical' 
    : templateName === 'soap_note' 
    ? 'SOAP Note' 
    : templateName}{/* Display the template name dynamically */}
        </div>
 {templateName===default_template ? (
      <div className="rounded-full border border-[rgba(36,99,235,0.20)] bg-[rgba(36,99,235,0.05)] px-4 py-1 text-xs text-[#2463EB] font-medium">Default</div>
      ) : (
        <div className="text-xs opacity-50 ml-2"></div>
      )}
      </div>
     
{/* <div
  onClick={(e) => {
    e.stopPropagation();
    setSelectedTemlate(templateName);
    // markasdefault(templateName)
  }}
  className={`font-medium h-[40px] text-xs py-1 px-2 rounded-sm transition duration-200 shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)] cursor-pointer flex items-center justify-center ${
    templateName === selectedTemplate ? 'bg-[#1C2A3A] text-white' : 'bg-white text-[#686868]'
  }`}
>
  Select Template
</div> */}


      {/* {templateName===default_template ?<EditIcon  onClick={() => navigate(`/edit-temp/${templateName}/ind`)} className="w-6 h-6 text-[#9CA3AF] cursor-pointer" alt="edit" />:<></>} */}
      {/* <RemoveRedEyeIcon  onClick={(e)=>
        {
          e.stopPropagation()
          handleShowpdf(templateName)}} className="w-6 h-6 text-[#9CA3AF] cursor-poinrunter" /> */}
    </div>
 </div></div> );
}):<>{loading?<>Getting Data</>:"No Data Available"}</>}

        </div>:(isListView==='corousel'?<>
          <div 
                  style={{
                    background: 'linear-gradient(180deg, #FFF 0%, #EFF6FF 100%)'
                  }}
            
                  className="flex   w-full justify-center  flex-wrap mt-2 mb-4 h-auto py-4">
          {/* <Corousel
        cards={cards}
        default_template={default_template}
        selectedTemplate={selectedTemplate}
        setSelectedTemlate={setSelectedTemlate}
        mydata={mydata}
    /> */}
     <FlickingCor
     cards={cards}
     default_template={default_template}
     selectedTemplate={selectedTemplate}
     setSelectedTemlate={setSelectedTemlate}
     mydata={mydata}
    />

        </div>


        </>:<>
       <div       ref={scrollRef} className="flex py-4  w-full justify-center max-h-[70vh] gap-4 overflow-y-auto custom-scrollbar flex-wrap mt-2">
  {sortedCards.map((card, index) => {
     let documentK;
          let documentData;
          const documentKey = Object.keys(card)[0];
          if (card.populatedtemp && typeof card.populatedtemp === 'object' && Object.keys(card.populatedtemp).length > 0) {
            documentK = 'populatedtemp';
            documentData = card.populatedtemp;
          } else {
            documentK= Object.keys(card)[0];
            documentData = card[documentK];
          }

    return (
      <div
      key={index}
      className={`flex-grow max-w-[49%] min-w-[350px] p-8 h-full min-h-[350px] rounded-lg border-2
        ${selectedTemplate === documentKey ?"border-[#A2C6FD]":'border-[#E5E7EB]'}  bg-white shadow-sm`}
    >
           {/* {documentKey===default_template ? (
        <div className="text-xs mb-2 opacity-50 ml-2">Default</div>
      ) : (
        <div className="text-xs mb-2 opacity-50 ml-2"> {documentKey === 'HnP' 
          ? 'History & Physical' 
          : documentKey === 'soap_note' 
          ? 'SOAP Note' 
          : documentKey}</div>
      )} */}       
        {mydata.usertype==='BASIC'?<><BasicDocView 
         setSelectedTemlate={setSelectedTemlate}
         documentKey={documentKey}
         selectedTemplate={selectedTemplate}
        data={documentData} defaulttemp={documentKey===default_template} /></>:<>
        <DocView 
         setSelectedTemlate={setSelectedTemlate}
         documentKey={documentKey}
         selectedTemplate={selectedTemplate}
        data={documentData} defaulttemp={documentKey===default_template} />
        </>
        }
         {documentKey === default_template ? (
          <div className="text-sm font-semibold text-[#1E293B] text-start mt-4 ">Default</div>
        ) : (
          <div className="text-sm font-semibold text-[#1E293B] mt-4 text-start ">
            {documentKey === 'HnP' ? 'History & Physical' : documentKey === 'soap_note' ? 'SOAP Note' : documentKey}
          </div>
        )}
      </div>
    );
  })}
</div>

       
        </>)}


      </div>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
      <TemplateUpdate 
      fetchBasicData={
        mydata.usertype==='BASIC'?
        fetchBasicData:fetchdata
        }
        defTemplatePrompt={defTemplatePrompt}
       setAlertMessage={setAlertMessage}      setOpen={setOpen} setSeverity={setSeverity}
      cards={cards}
      selectedTemplate={selectedTemplate}
      ismodal={isupdatemodal} setismodal={setIsupdatemodal} />
      <PromptActionsModal
            setSeverity={setSeverity}
            setOpen={setOpen}
            setAlertMessage={setAlertMessage}
            setLoadings={setLoading}
            selectedTemplate={selectedTemplate}
            ismodal={isPromptactions} onClose={setIspromptActions}  />

      <ShowPdf ispdfshow={ispdfshow} setIspdfShow={setIspdfShow} pdfBlob={pdffile} selectedTemplate={selectedTemplate}/>
      <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
      {/* {isuploadmodal?
      <UploadFileModal 
      setAlertMessage={setAlertMessage}
      
      setExtractionResponse={setExtractionResponse}
      setOpen={setOpen}
      setfile={setFile} 
      setIsuploadmodal={setIsuploadmodal}/>
      
      :<></>} */}
      <SectionUpdate fetchBasicData={
        mydata.usertype==='BASIC'?
        fetchBasicData:fetchdata
        } modal={isuploadmodal} setIsuploadmodal={setIsuploadmodal} cards={cards}   setAlertMessage={setAlertMessage}      setOpen={setOpen} setSeverity={setSeverity}/>
    </div>
 </div>
 </> );
};

export default ManageTemplate;
